// extracted by mini-css-extract-plugin
module.exports = {"light":"style_light__2F9TJ","subTabs":"style_subTabs__3j7Eh","subTab":"style_subTab__3Xp6M","active":"style_active__2OoU6","subTabPlaceholder":"style_subTabPlaceholder__1Rlct"};